

<div class="financeiro-aviso">
  <p>
    <span>FINANCEIRO</span>
  </p>
  <p> Para realizar pedidos, acessar suas notas fiscais, cópias de pedidos e segunda via de
    boletos clique no link
    abaixo:</p>
    <p>
      <a href="https://portaldolojista.blukit.com.br/auth" target="_blank">www.blukit.com.br/portaldolojista</a>
    </p>
    <p>Ficou com dúvidas para acessar? Clique <a href="https://www.youtube.com/watch?v=DKgZyHijli0" target="_blank">aqui</a> e
      assista nosso tutorial de acesso. </p>
      <span >Caso deseje alterar o e-mail cadastrado ou em caso de dúvidas, gentileza entrar em contato através do
        canal abaixo:</span>

      </div>

  <div class="container pt-4">

  <div class="description-text description-text__blue text-center pb-2 pb-md-4">Enviar e-mail</div>

  <form [formGroup]="formFinanceiro" (submit)="onSubmit('Financeiro')">


    <div class="container">
      <div class="row ">
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" formControlName="razao" required type="text"
              (change)="saverange($event, 'razao' )" placeholder="Razão Social"
              [class.error]="formFinanceiro.controls['razao'].errors && (formFinanceiro.controls['razao'].dirty || (formFinanceiro.controls['razao'].touched || submitted) ) " />

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['razao'].errors?.['required']  && (formFinanceiro.controls['razao'].dirty || (formFinanceiro.controls['razao'].touched || submitted) )">
              Razão Social é necessária.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['razao'].errors?.['required'] && (formFinanceiro.controls['razao'].dirty || (formFinanceiro.controls['razao'].touched) || submitted) && formFinanceiro.controls['razao'].errors ">
              Razão Social inválida.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" formControlName="cnpjCpf" mask="00.000.000/0000-00" type="text"
              placeholder="CNPJ"
              [class.error]="formFinanceiro.controls['cnpjCpf'].errors && (formFinanceiro.controls['cnpjCpf'].dirty || (formFinanceiro.controls['cnpjCpf'].touched || submitted))" />

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['cnpjCpf'].errors?.['required'] && (formFinanceiro.controls['cnpjCpf'].dirty || (formFinanceiro.controls['cnpjCpf'].touched || submitted))">
              CNPJ é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['cnpjCpf'].errors?.['required'] && (formFinanceiro.controls['cnpjCpf'].dirty || (formFinanceiro.controls['cnpjCpf'].touched)|| submitted) && formFinanceiro.controls['cnpjCpf'].errors">
              CNPJ inválido.
            </span>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control  global-input-style" formControlName="nome" type="text" name="nome"
              (change)="saverange($event, 'nome')" placeholder="Nome"
              [class.error]="formFinanceiro.controls['nome'].errors && (formFinanceiro.controls['nome'].dirty || (formFinanceiro.controls['nome'].touched) || submitted)" />

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['nome'].errors?.['required'] && (formFinanceiro.controls['nome'].dirty || (formFinanceiro.controls['nome'].touched) || submitted)">
              Nome é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['nome'].errors?.['required'] && (formFinanceiro.controls['nome'].dirty || (formFinanceiro.controls['nome'].touched) || submitted) && formFinanceiro.controls['nome'].errors">
              Nome inválido.
            </span>

          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" type="text" formControlName="nota"
              placeholder="Número da Nota (opcional)" (change)="saverange($event, 'nota' )" />

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style " formControlName="email" type="text" placeholder="E-mail"
              (change)="saverange($event, 'email' )"
              [class.error]="formFinanceiro.controls['email'].errors && (formFinanceiro.controls['email'].dirty || (formFinanceiro.controls['email'].touched)|| submitted)" />

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['email'].errors?.['required'] && (formFinanceiro.controls['email'].dirty || (formFinanceiro.controls['email'].touched)|| submitted)">
              E-mail é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['email'].errors?.['required'] && (formFinanceiro.controls['email'].dirty || (formFinanceiro.controls['email'].touched)|| submitted) && formFinanceiro.controls['email'].errors">
              E-mail inválido.
            </span>

          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" formControlName="telefone" type="text"
              mask="(00)0000-0000 || (00)00000-0000 " placeholder="Telefone"
              [class.error]="formFinanceiro.controls['telefone'].errors && (formFinanceiro.controls['telefone'].dirty || (formFinanceiro.controls['telefone'].touched)|| submitted)" />
            <span class="text-danger"
              *ngIf="formFinanceiro.controls['telefone'].errors?.['required'] && (formFinanceiro.controls['telefone'].dirty || (formFinanceiro.controls['telefone'].touched)|| submitted)">
              Telefone é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['telefone'].errors?.['required'] && (formFinanceiro.controls['telefone'].dirty || (formFinanceiro.controls['telefone'].touched)|| submitted) && formFinanceiro.controls['telefone'].errors">
              Telefone inválido.
            </span>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" type="text" formControlName="endereco"
              (change)="saverange($event, 'endereco')" placeholder="Endereço"
              [class.error]="formFinanceiro.controls['endereco'].errors && (formFinanceiro.controls['endereco'].dirty || (formFinanceiro.controls['endereco'].touched)|| submitted)" />

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['endereco'].errors?.['required'] && (formFinanceiro.controls['endereco'].dirty || (formFinanceiro.controls['endereco'].touched)|| submitted)">
              Endereço é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['endereco'].errors?.['required'] && (formFinanceiro.controls['endereco'].dirty || (formFinanceiro.controls['endereco'].touched)|| submitted) && formFinanceiro.controls['endereco'].errors">
              Endereço inválido.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" formControlName="cep" type="text" mask="00000-000"
              placeholder="CEP"
              [class.error]="formFinanceiro.controls['cep'].errors && (formFinanceiro.controls['cep'].dirty || (formFinanceiro.controls['cep'].touched)|| submitted)" />
            <span class="text-danger"
              *ngIf="formFinanceiro.controls['cep'].errors?.['required'] && (formFinanceiro.controls['cep'].dirty || (formFinanceiro.controls['cep'].touched)|| submitted)">
              CEP é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['cep'].errors?.['required'] && (formFinanceiro.controls['cep'].dirty || (formFinanceiro.controls['cep'].touched)|| submitted) && formFinanceiro.controls['cep'].errors">
              CEP inválido.
            </span>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input class="form-control global-input-style" formControlName="bairro" type="text" placeholder="Bairro"
              (change)="saverange($event, 'bairro')"
              [class.error]="formFinanceiro.controls['bairro'].errors && (formFinanceiro.controls['bairro'].dirty || (formFinanceiro.controls['bairro'].touched)|| submitted)" />

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['bairro'].errors?.['required'] && (formFinanceiro.controls['bairro'].dirty || (formFinanceiro.controls['bairro'].touched)|| submitted)">
              Bairro é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!formFinanceiro.controls['bairro'].errors?.['required'] && (formFinanceiro.controls['bairro'].dirty || (formFinanceiro.controls['bairro'].touched)|| submitted) && formFinanceiro.controls['bairro'].errors">
              Bairro inválido.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <select class="form-select" formControlName="interesse"
              [class.error]="formFinanceiro.controls['interesse'].errors?.['required'] && (formFinanceiro.controls['interesse'].dirty || (formFinanceiro.controls['interesse'].touched)|| submitted)">
              <option disabled selected value="" [selected]="!formFinanceiro.controls['interesse'].value">Selecione
                sua necessidade</option>
              <option *ngFor="let option of optionsInteresse" [value]="option.value">
                {{ option.viewValue }}
              </option>
            </select>

            <span class="text-danger"
              *ngIf="formFinanceiro.controls['interesse'].errors?.['required'] && (formFinanceiro.controls['interesse'].dirty || (formFinanceiro.controls['interesse'].touched)|| submitted)">
              Selecione uma opção.
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <select class="form-select" formControlName="estado"
              [class.error]="formFinanceiro.controls['estado'].errors?.['required'] && (formFinanceiro.controls['estado'].dirty || (formFinanceiro.controls['estado'].touched)|| submitted)">
              <option value="" disabled [selected]="!formFinanceiro.controls['estado'].value">Selecione um estado
              </option>
              <option *ngFor="let estado of listaEstados" [value]="estado.nome">{{estado.nome}}</option>
            </select>
            <span class="text-danger"
              *ngIf="formFinanceiro.controls['estado'].errors?.['required'] && (formFinanceiro.controls['estado'].dirty || (formFinanceiro.controls['estado'].touched)|| submitted)">
              Selecione um estado.
            </span>

          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <select class="form-select " formControlName="cidade"
              [class.error]="formFinanceiro.controls['cidade'].errors?.['required'] && (formFinanceiro.controls['cidade'].dirty || (formFinanceiro.controls['cidade'].touched)|| submitted)">
              <option value="" *ngIf="formFinanceiro.controls['estado'].errors">Selecione um estado primeiro </option>
              <option value="" [selected]="!formFinanceiro.controls['cidade'].value"
                *ngIf="!formFinanceiro.controls['estado'].errors">Selecione uma cidade</option>
              <option *ngFor="let cidade of listaCidades[0]" [value]="cidade">{{cidade}} </option>
            </select>
            <span class="text-danger"
              *ngIf="formFinanceiro.controls['cidade'].errors?.['required'] && (formFinanceiro.controls['cidade'].dirty || (formFinanceiro.controls['cidade'].touched)|| submitted)">
              Selecione a cidade.
            </span>
          </div>
        </div>
      </div>

      <div class="row ">
        <div class="col-md-12">

          <textarea class="form-control" id="mensagem" formControlName="mensagem"  style="height:auto!important; resize: none;" rows="6"
            placeholder="Mensagem" (change)="saverange($event, 'mensagem')" (input)="contarCaracteres($event)"
            [class.error]="formFinanceiro.controls['mensagem'].errors && (formFinanceiro.controls['mensagem'].dirty || (formFinanceiro.controls['mensagem'].touched)|| submitted)"></textarea>

          <span class="text-danger"
            *ngIf="formFinanceiro.controls['mensagem'].errors?.['required'] && (formFinanceiro.controls['mensagem'].dirty || (formFinanceiro.controls['mensagem'].touched)|| submitted)">
            Mensagem é necessária.
          </span>
          <span class="text-danger"
            *ngIf="!formFinanceiro.controls['mensagem'].errors?.['required'] && (formFinanceiro.controls['mensagem'].dirty || (formFinanceiro.controls['mensagem'].touched)|| submitted) && formFinanceiro.controls['mensagem'].errors">
            Mensagem inválido. {{quantidadeCaracteres}} caractere(s) restante(s).
          </span>

        </div>

      </div>

            <button  [disabled]="submitted" class="btn-submit-form"  type="submit" >
              ENVIAR
            </button>

    </div>
  </form>




